export const visit = (vm, at) => {
at({ "en": { "publicPricingPage": { "comparePlansLink": "See all features and compare plans in detail" } } });
};